import { createStyles } from '@material-ui/core/styles';

export default () =>
  createStyles({
    content: {
      display: 'block',
      backgroundColor: '#0000001c',
      borderRadius: '4px',
      animation: 'skeleton 1.5s ease-in-out 0.5s infinite',
    },
    '@keyframes skeleton': {
      '0%': {
        opacity: '1',
      },
      '50%': {
        opacity: '0.4',
      },
      '100%': {
        opacity: '1',
      },
    },
  });
